import { _ as _objectSpread2, b as _objectWithoutPropertiesLoose, a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers-ac7c98be.js';
import { css, cx } from 'emotion';
import { useDarken } from 'reakit-system-palette/utils/darken';
import { useContrast } from 'reakit-system-palette/utils/contrast';
import { usePalette } from 'reakit-system-palette/utils/palette';
import { useContext, useCallback, createElement, cloneElement, Fragment, createContext } from 'react';

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inherit;\n    flex-direction: inherit;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    outline: 0;\n\n    &[aria-checked=\"true\"] {\n      &:before {\n        content: \"\u2022\";\n        position: absolute;\n        font-size: 1.4em;\n        top: -0.25em;\n        left: 0.35em;\n        width: 0.7142857143em;\n        height: 0.7142857143em;\n      }\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    outline: 0;\n\n    &[aria-checked=\"true\"] {\n      &:before {\n        content: \"\u2713\";\n        position: absolute;\n        top: 0;\n        left: 0.4em;\n        width: 1em;\n        height: 1em;\n      }\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n          margin-", ": 0.5em;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n        padding-right: 2em !important;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n\n    [role=\"menu\"] > & {\n      ", "\n    }\n\n    svg {\n      fill: currentColor;\n      width: 0.65em;\n      height: 0.65em;\n\n      [role=\"menu\"] > & {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        ", ": 0.5em;\n      }\n\n      [role=\"menubar\"] > & {\n        display: none;\n      }\n\n      ", "\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    border-radius: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    &&& {\n      line-height: 1.5;\n      padding: 0 ", ";\n      text-align: left;\n      justify-content: flex-start;\n      border: 0;\n      border-radius: 0;\n      font-size: 100%;\n      background: transparent;\n      color: ", ";\n      margin: 0;\n      user-select: none;\n      cursor: default;\n      text-decoration: none;\n\n      &:focus,\n      &[aria-expanded=\"true\"] {\n        background-color: ", ";\n        color: ", ";\n        box-shadow: none !important;\n      }\n\n      &:active,\n      &[data-active] {\n        background-color: ", " !important;\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    flex-direction: ", ";\n    white-space: nowrap;\n    box-shadow: none !important;\n\n    &[aria-orientation=\"vertical\"] {\n      padding: 0.25em 0;\n    }\n\n    &[aria-orientation=\"horizontal\"] {\n      padding: 0;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
function useMenuBarProps(options, htmlProps) {
  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var isHorizontal = options.orientation === "horizontal";
  var menuBar = css(_templateObject(), isHorizontal ? "row" : "column");
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    className: cx(menuBar, htmlProps.className)
  });
}
function useMenuItemProps(_ref, htmlProps) {
  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var unstable_system = _ref.unstable_system,
      options = _objectWithoutPropertiesLoose(_ref, ["unstable_system"]);

  var foreground = usePalette("foreground") || "black";
  var primary = usePalette("primary") || "blue";
  var primaryContrast = useContrast(primary);
  var darkPrimary = useDarken(primary, 0.2);
  var isHorizontal = options.orientation === "horizontal";
  var menuItem = css(_templateObject2(), isHorizontal ? "0.5em" : "1.5em", foreground, primary, primaryContrast, darkPrimary);
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    className: cx(menuItem, htmlProps.className)
  });
}
var OrientationContext = /*#__PURE__*/createContext(undefined);
function useMenuOptions(_ref2) {
  var _options$unstable_pop;

  var _ref2$unstable_system = _ref2.unstable_system;
  _ref2$unstable_system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system;

  var _ref2$unstable_system2 = _ref2$unstable_system.palette,
      palette = _ref2$unstable_system2 === void 0 ? "background" : _ref2$unstable_system2,
      _ref2$unstable_system3 = _ref2$unstable_system.fill,
      fill = _ref2$unstable_system3 === void 0 ? "opaque" : _ref2$unstable_system3,
      system = _objectWithoutPropertiesLoose(_ref2$unstable_system, ["palette", "fill"]),
      options = _objectWithoutPropertiesLoose(_ref2, ["unstable_system"]);

  var parentOrientation = useContext(OrientationContext);

  var unstable_system = _objectSpread2({
    palette: palette,
    fill: fill
  }, system);

  var transform = ((_options$unstable_pop = options.unstable_popoverStyles) === null || _options$unstable_pop === void 0 ? void 0 : _options$unstable_pop.transform) || "";

  if (parentOrientation === "vertical" && options.orientation === "vertical") {
    return _objectSpread2(_objectSpread2({}, options), {}, {
      unstable_system: unstable_system,
      unstable_popoverStyles: _objectSpread2(_objectSpread2({}, options.unstable_popoverStyles), {}, {
        transform: transform + " translate3d(0px, -0.3em, 0px)"
      })
    });
  }

  return _objectSpread2(_objectSpread2({}, options), {}, {
    unstable_system: unstable_system
  });
}
function useMenuProps(options, _ref3) {
  if (_ref3 === void 0) {
    _ref3 = {};
  }

  var _ref4 = _ref3,
      htmlWrapElement = _ref4.wrapElement,
      htmlProps = _objectWithoutPropertiesLoose(_ref4, ["wrapElement"]);

  var menu = css(_templateObject3());
  var wrapElement = useCallback(function (element) {
    if (htmlWrapElement) {
      element = htmlWrapElement(element);
    }

    return /*#__PURE__*/createElement(OrientationContext.Provider, {
      value: options.orientation
    }, element);
  }, [htmlWrapElement, options.orientation]);
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    wrapElement: wrapElement,
    className: cx(menu, htmlProps.className)
  });
}
function useMenuButtonProps(options, _ref5) {
  if (_ref5 === void 0) {
    _ref5 = {};
  }

  var _ref6 = _ref5,
      children = _ref6.children,
      htmlProps = _objectWithoutPropertiesLoose(_ref6, ["children"]);

  var placement = options.unstable_originalPlacement || options.placement;
  var dir = placement ? placement.split("-")[0] : undefined;
  var svg = dir ? {
    top: /*#__PURE__*/createElement("svg", {
      viewBox: "0 0 50 43.3"
    }, /*#__PURE__*/createElement("polygon", {
      points: "25 0 0 43.3 50 43.3 25 0"
    })),
    bottom: /*#__PURE__*/createElement("svg", {
      viewBox: "0 0 50 43.3"
    }, /*#__PURE__*/createElement("polygon", {
      points: "25 43.3 50 0 0 0 25 43.3"
    })),
    right: /*#__PURE__*/createElement("svg", {
      viewBox: "0 0 43.3 50"
    }, /*#__PURE__*/createElement("polygon", {
      points: "43.3 25 0 0 0 50 43.3 25"
    })),
    left: /*#__PURE__*/createElement("svg", {
      viewBox: "0 0 43.3 50"
    }, /*#__PURE__*/createElement("polygon", {
      points: "0 25 43.3 50 43.3 0 0 25"
    }))
  }[dir] : null;
  var menuButton = css(_templateObject4(), children && dir !== "left" && css(_templateObject5()), dir === "left" ? "left" : "right", children && css(_templateObject6(), dir === "left" ? "right" : "left"));
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    children: typeof children === "function" ? function (props) {
      var child = children(props);
      return /*#__PURE__*/cloneElement(child, {
        children: /*#__PURE__*/createElement(Fragment, null, child.props.children, svg)
      });
    } : /*#__PURE__*/createElement(Fragment, null, children, svg),
    className: cx(menuButton, htmlProps.className)
  });
}
function useMenuItemCheckboxProps(_, htmlProps) {
  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var menuItemCheckbox = css(_templateObject7());
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    className: cx(menuItemCheckbox, htmlProps.className)
  });
}
function useMenuItemRadioProps(_, htmlProps) {
  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var menuItemRadio = css(_templateObject8());
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    className: cx(menuItemRadio, htmlProps.className)
  });
}
function useMenuGroupProps(_, htmlProps) {
  if (htmlProps === void 0) {
    htmlProps = {};
  }

  var menuGroup = css(_templateObject9());
  return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
    className: cx(menuGroup, htmlProps.className)
  });
}

export { useMenuBarProps, useMenuButtonProps, useMenuGroupProps, useMenuItemCheckboxProps, useMenuItemProps, useMenuItemRadioProps, useMenuOptions, useMenuProps };
